var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 31,
    viewBox: "0 0 4 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 11,
    r: 2,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 20,
    r: 2,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 29,
    r: 2,
    fill: "#C9C9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 31,
    rx: 2,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle);
export default __webpack_public_path__ + "static/media/handle.7248d6c6f963fe65305d5dc6c9fc1786.svg";
export { ForwardRef as ReactComponent };